import { useState } from 'react'

const useModalCreditCardError = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [errorMsg, setErrorMsg] = useState<string>('')

  function open(errorMsg: string) {
    setErrorMsg(errorMsg)
    setIsOpen(true)
  }

  function close() {
    setIsOpen(false)
  }

  return {
    props: {
      isOpen,
      error: errorMsg,
    },
    open,
    close,
  }
}

export default useModalCreditCardError
